import { render, staticRenderFns } from "./OutBoxMessageList.vue?vue&type=template&id=e43d0f50&scoped=true&"
import script from "./OutBoxMessageList.vue?vue&type=script&lang=js&"
export * from "./OutBoxMessageList.vue?vue&type=script&lang=js&"
import style0 from "./OutBoxMessageList.vue?vue&type=style&index=0&id=e43d0f50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43d0f50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
